import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import AppBar from 'material-ui/AppBar';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import * as actions from '../../actions';
import ReviewDashboard from './ReviewDashboard';
import ChekkitDashboard from './ChekkitDashboard';
import AddAccountsDashboard from './AddAccountsDashboard';
import SettingsDashboard from './SettingsDashboard';

const Greeting = styled.span`
	color: darkgrey;
	text-transform: uppercase;
	font-size: 13px;
	font-weight: 600;
	letter-spacing: 1px;
	margin-right: 40px;
	margin-top: 10px;
`;

const muiTheme = getMuiTheme(
	{ lightBaseTheme },
	{
		fontFamily: 'Geist Sans, sans-serif',
		palette: {
			primary1Color: '#c655d6'
		}
	}
);

const styles = {
	container: { margin: 'auto', maxWidth: 1400 }
};

const headerLight = {
	backgroundColor: '#fff',
	top: '0',
	marginTop: '0'
};

const logoButton = {
	marginLeft: '15%',
	height: '100%',
	display: 'flex',
	alignItems: 'center'
};

const top15 = {
	marginBottom: '8px'
};

const boringText = {
	color: 'darkgrey',
	marginRight: '2em'
};

const logoLight = {
	color: 'black'
};

class BusinessDashboard extends Component {
	constructor(props) {
		super(props);

		const active = props.auth._corporate ? 'chekkit' : 'reviews';
		const activeIndex = props.auth._corporate ? 1 : 0;

		this.state = {
			active,
			width: window.innerWidth,
			activeIndex
		};
	}

	componentWillMount() {
		document.title = 'Chekkit Enterprise Dashboard';

		window.addEventListener('resize', this.handleWindowSizeChange);
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
	}

	getMonthlyMessages = () => <span />;

	handleWindowSizeChange = () => {
		this.setState({ width: window.innerWidth });
	};

	renderHeader = () => (
		<div className="logo" style={logoButton}>
			<a
				className="waves-effect waves-light"
				style={{
					...logoLight,
					display: 'flex',
					alignItems: 'center',
					height: '100%'
				}}
				href={this.props.auth ? '/dashboard' : '/'}
			>
				<img
					alt="chekkit logo"
					style={{ width: '82px', display: 'block' }}
					src="/img/chekkit-logo.svg"
				/>
			</a>
		</div>
	);

	renderContent = () => {
		const isMobile = this.state.width <= 640;
		const isTablet = this.state.width > 640 && this.state.width < 1126;

		if (isMobile) {
			return (
				<div>
					<IconMenu
						{...this.props}
						iconButtonElement={
							<IconButton>
								<MoreVertIcon className="mobile-dashboard" />
							</IconButton>
						}
						targetOrigin={{
							horizontal: 'right',
							vertical: 'top'
						}}
						anchorOrigin={{
							horizontal: 'right',
							vertical: 'top'
						}}
					>
						<MenuItem
							className={
								this.state.activeIndex === 0
									? 'chkt-btn-small decorated'
									: 'chkt-btn-small'
							}
							href="#reviews"
							primaryText="Reviews"
							onClick={() => {
								this.setState({
									active: 'reviews',
									activeIndex: 0
								});
							}}
						/>
						{this.props.auth._corporate ? (
							<MenuItem
								className={
									this.state.activeIndex === 0
										? 'chkt-btn-small decorated'
										: 'chkt-btn-small'
								}
								href="#chekkit"
								primaryText="Chekkit"
								onClick={() => {
									this.setState({
										active: 'chekkit',
										activeIndex: 1
									});
								}}
							/>
						) : (
							<span />
						)}

						<MenuItem
							className={
								this.state.activeIndex === 1
									? 'chkt-btn-small decorated'
									: 'chkt-btn-small'
							}
							href="#settings"
							primaryText="Settings"
							onClick={() => {
								this.setState({
									active: 'settings',
									activeIndex: 2
								});
							}}
						/>

						<MenuItem
							className={
								this.state.activeIndex === 2
									? 'chkt-btn-small decorated'
									: 'chkt-btn-small'
							}
							href="#locations"
							primaryText="Add Location"
							onClick={() => {
								this.setState({
									active: 'addAccounts',
									activeIndex: 3
								});
							}}
						/>
						<MenuItem href="/api/logout" primaryText="Logout" />
					</IconMenu>
				</div>
			);
		} else if (isTablet) {
			return (
				<div>
					<span className="btn-small" style={boringText} />
					<span className="btn-small" style={boringText} />

					<IconMenu
						{...this.props}
						iconButtonElement={
							<IconButton>
								<MoreVertIcon className="mobile-dashboard" />
							</IconButton>
						}
						targetOrigin={{
							horizontal: 'right',
							vertical: 'top'
						}}
						anchorOrigin={{
							horizontal: 'right',
							vertical: 'top'
						}}
					>
						<MenuItem
							className={
								this.state.activeIndex === 0
									? 'chkt-btn-small decorated'
									: 'chkt-btn-small'
							}
							href="#reviews"
							primaryText="Reviews"
							onClick={() => {
								this.setState({
									active: 'reviews',
									activeIndex: 0
								});
							}}
						/>

						{this.props.auth._corporate ? (
							<MenuItem
								className={
									this.state.activeIndex === 1
										? 'chkt-btn-small decorated'
										: 'chkt-btn-small'
								}
								href="#chekkit"
								primaryText="Chekkit"
								onClick={() => {
									this.setState({
										active: 'chekkit',
										activeIndex: 1
									});
								}}
							/>
						) : (
							<span />
						)}

						<MenuItem
							className={
								this.state.activeIndex === 2
									? 'chkt-btn-small decorated'
									: 'chkt-btn-small'
							}
							href="#settings"
							primaryText="Settings"
							onClick={() => {
								this.setState({
									active: 'settings',
									activeIndex: 2
								});
							}}
						/>

						<MenuItem
							className={
								this.state.activeIndex === 3
									? 'chkt-btn-small decorated'
									: 'chkt-btn-small'
							}
							href="#location"
							primaryText="Add Locations"
							onClick={() => {
								this.setState({
									active: 'addAccounts',
									activeIndex: 3
								});
							}}
						/>
						<MenuItem href="/api/logout" primaryText="Logout" />
					</IconMenu>
				</div>
			);
		}
		return (
			<div style={top15}>
				<span className="btn-small" style={boringText} />
				<span className="btn-small" style={boringText} />
				<Greeting>Hi, {this.props.auth.name}</Greeting>
				<a
					className={
						this.state.activeIndex === 0
							? 'chkt-btn-small decorated'
							: 'chkt-btn-small'
					}
					onClick={() => {
						this.setState({
							active: 'reviews',
							activeIndex: 0
						});
					}}
					href="#reviews"
				>
					Reviews
				</a>
				{this.props.auth._corporate || this.props.auth._reseller ? (
					<a
						className={
							this.state.activeIndex === 1
								? 'chkt-btn-small decorated'
								: 'chkt-btn-small'
						}
						onClick={() => {
							this.setState({
								active: 'chekkit',
								activeIndex: 1
							});
						}}
						href="#chekkit"
					>
						Chekkit
					</a>
				) : (
					<span />
				)}
				<a
					className={
						this.state.activeIndex === 2
							? 'chkt-btn-small decorated'
							: 'chkt-btn-small'
					}
					onClick={() => {
						this.setState({
							active: 'settings',
							activeIndex: 2
						});
					}}
					href="#settings"
				>
					Settings
				</a>
				<a
					className={
						this.state.activeIndex === 3
							? 'chkt-btn-small decorated'
							: 'chkt-btn-small'
					}
					onClick={() => {
						this.setState({
							active: 'addAccounts',
							activeIndex: 3
						});
					}}
					href="#locations"
				>
					Add Accounts
				</a>

				<a className="chkt-btn-small" href="/api/logout">
					Logout
				</a>
			</div>
		);
	};

	renderReviews = () => (
		<div style={styles.container}>
			<ReviewDashboard />
		</div>
	);

	renderChekkit = () => (
		<div style={styles.container}>
			<ChekkitDashboard />
		</div>
	);

	renderSettings = () => (
		<div style={styles.container}>
			<SettingsDashboard />
		</div>
	);

	renderAddAccounts = () => (
		<div style={styles.container}>
			<AddAccountsDashboard />
		</div>
	);

	renderComponent = () => {
		switch (this.state.active) {
			case 'reviews':
				return this.renderReviews();
			case 'chekkit':
				return this.renderChekkit();
			case 'settings':
				return this.renderSettings();
			case 'addAccounts':
				return this.renderAddAccounts();
			default:
				return this.renderReviews();
		}
	};

	render() {
		return (
			<div>
				<MuiThemeProvider muiTheme={muiTheme}>
					<div style={{ height: 60 }}>
						<AppBar
							id="app-bar"
							title={this.renderHeader()}
							zDepth={0}
							showMenuIconButton={false}
							style={headerLight}
							iconElementRight={this.renderContent()}
						/>
					</div>
				</MuiThemeProvider>
				{this.renderComponent()}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		waiting: state.waiting,
		error: state.error,
		auth: state.auth
	};
}

export default connect(mapStateToProps, actions)(BusinessDashboard);



// WEBPACK FOOTER //
// ./src/components/dashboards/EnterpriseDashboard.js